/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S1_Body_PostInputs */

const tr_servis_s1_body_post = /** @type {(inputs: Servis_S1_Body_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'nın ayrılmaz bir ekidir. Hüküm çatışması halinde bu Servis Sözleşmesi'nin özel hükümleri öncelikle uygulanır.`)
};

const en_servis_s1_body_post = /** @type {(inputs: Servis_S1_Body_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. In the event of a conflict of provisions, the special provisions of this Service Agreement shall prevail.`)
};

const de_servis_s1_body_post = /** @type {(inputs: Servis_S1_Body_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Bei einem Widerspruch der Bestimmungen gehen die besonderen Bestimmungen dieses Servicevertrags vor.`)
};

const ru_servis_s1_body_post = /** @type {(inputs: Servis_S1_Body_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. В случае противоречия положений преимущественную силу имеют специальные положения настоящего Сервисного договора.`)
};

/**
* | output |
* | --- |
* | ". In the event of a conflict of provisions, the special provisions of this Service Agreement shall prevail." |
*
* @param {Servis_S1_Body_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s1_body_post = /** @type {((inputs?: Servis_S1_Body_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S1_Body_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s1_body_post(inputs)
	if (locale === "de") return de_servis_s1_body_post(inputs)
	if (locale === "ru") return ru_servis_s1_body_post(inputs)
	return tr_servis_s1_body_post(inputs)
});